import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[UnMask]'
})
export class UnMaskDirective implements OnInit, OnDestroy {

  // tslint:disable-next-line:no-input-rename
  @Input('UnMask') unmask: string;

  private subscriber;

  constructor(
    private elementRef: ElementRef,
    private model: NgControl
  ) { }

  ngOnInit(): void {
    this.subscriber = this.model.control.valueChanges.subscribe(() => {
      const newValue = this.elementRef.nativeElement.value.replace(new RegExp(this.unmask), '');
      this.model.control.setValue(newValue, {
        emitEvent: false,
        emitModelToViewChange: false,
        emitViewToModelChange: false
      });
    });
  }

  ngOnDestroy() {
    this.subscriber && this.subscriber.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/UnMaskInput/un-mask.directive.ts